import React, { useState } from "react";
import s from "./PopoverItems.module.scss";
import EyeOpen from "../../../../../../../global components/Icons/EyeOpen/EyeOpen";
import Edit from "../../../../../../../global components/Icons/Edit/Edit";
import { useNavigate } from "react-router-dom";

import ReusableModal from "../../../../../../../global components/Modal/Modal";
import clsx from "clsx";
import { Oval } from "react-loader-spinner";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../libs/api/userSession";
import { SuccessDataType } from "../../../../../../../libs/api/types";
import { generateConfirmation } from "../../../../../../../global components/DestructiveModal/DestruvtiveModal";
import { generateResult } from "../../../../../../../global components/ResultModal/ResultModal";
import GiftUser from "../../GiftUser";
interface PopOverItemsProps {
  keyValue: string; // Add a prop for the key value
  mutate: () => void;
  isSuspended?: boolean;
  name?: string | undefined;
  status: string;
}
function PopOverItems({
  keyValue,
  mutate,
  isSuspended,
  name,
  status,
}: PopOverItemsProps) {
  const [showModal, setShow] = useState<boolean>(false);
  const { trigger: changeUser, isMutating } = useSWRMutation(
    `api/admin/users/${keyValue}/${isSuspended ? "reinstate" : "suspend"}`,
    swrMutationFetcher
  );

  const token = UseAuthToken();
  const mutateUser = async () => {
    try {
      const fetcherArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "POST",
        },
      };
      const result: SuccessDataType<any> = await changeUser(fetcherArg);
      generateResult(
        "success",
        result.message.charAt(0).toUpperCase() + result.message.slice(1)
      );
      mutate();
    } catch (error) {
      const e = parseClientError(error);

      generateResult("error", e.message || e.error);
    }
  };

  const navigate = useNavigate();
  const handleModal = () => {
    setShow((prev) => !prev);
  };
  return (
    <>
      <ReusableModal
        handleModal={handleModal}
        isModalOpen={showModal}
        centered
        title={""}
      >
        <GiftUser handleClose={handleModal} userId={keyValue} name={name} />
      </ReusableModal>
      <div className={s.wrapper}>
        <span
          onClick={() =>
            navigate(`/dashboard/users/profile?userId=${keyValue}`)
          }
          className={clsx(s.PopOverItem)}
        >
          <EyeOpen fill="#240806" />
          <h5>View details</h5>
        </span>

        <span
          onClick={() =>
            generateConfirmation(
              `${isSuspended ? "Reinstate" : "Suspend"} user?`,
              `Are you sure you want to ${
                isSuspended ? "reinstate" : "suspend"
              } this user?`,
              mutateUser,
              isMutating,
              isSuspended ? "reinstate" : "suspend"
            )
          }
          className={s.PopOverItem}
        >
          <Edit width={18} height={18} />
          <h5>{isSuspended ? "Reinstate" : "Suspend"} user</h5>
          <Oval
            visible={isMutating}
            height="18"
            width="18"
            color="#d52b1e"
            ariaLabel="oval-loading"
          />
        </span>
        {/* <span onClick={handleModal} className={clsx(s.PopOverItem)}>
          <Gift height={15} width={15} />
          <h5>Gift user credits</h5>
        </span> */}
      </div>
    </>
  );
}

export default PopOverItems;
